import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=1bc0a410&"
import script from "./rejectDialog.vue?vue&type=script&lang=js&"
export * from "./rejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc0a410')) {
      api.createRecord('1bc0a410', component.options)
    } else {
      api.reload('1bc0a410', component.options)
    }
    module.hot.accept("./rejectDialog.vue?vue&type=template&id=1bc0a410&", function () {
      api.rerender('1bc0a410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/verify/rejectDialog.vue"
export default component.exports